import { useEffect, useState } from "react";
import api from "@/lib/api";

const fmt = (n) => (n || 0).toLocaleString();
const lines = (s) => [
  s.alerts_year > 0 && `${fmt(s.alerts_year)} expiration alert${s.alerts_year === 1 ? "" : "s"} caught in ${s.year}`,
  s.drivers > 0 && `${fmt(s.drivers)} driver${s.drivers === 1 ? "" : "s"} kept DOT-qualified`,
  s.vehicles > 0 && `${fmt(s.vehicles)} unit${s.vehicles === 1 ? "" : "s"} tracked for registration and inspection`,
  s.reports_year > 0 && `${fmt(s.reports_year)} MVR, PSP and background report${s.reports_year === 1 ? "" : "s"} ordered this year`,
  s.filings_year > 0 && `${fmt(s.filings_year)} IRP, 2290 and IFTA filing${s.filings_year === 1 ? "" : "s"} completed this year`,
  s.signatures > 0 && `${fmt(s.signatures)} form${s.signatures === 1 ? "" : "s"} signed electronically`,
  s.randoms > 0 && `${fmt(s.randoms)} random selection${s.randoms === 1 ? "" : "s"} tracked to completion`,
  s.carriers > 0 && `${fmt(s.carriers)} carrier${s.carriers === 1 ? "" : "s"} on the consortium portal`,
].filter(Boolean);

export function HeroTicker() {
  const [items, setItems] = useState(["Expirations, randoms and filings — tracked, reminded and approved"]);
  const [i, setI] = useState(0);
  const [show, setShow] = useState(true);
  useEffect(() => { api.get("/public/stats").then(({ data }) => { const l = lines(data); if (l.length) setItems(l); }).catch(() => {}); }, []);
  useEffect(() => {
    if (items.length < 2) return;
    const t = setInterval(() => { setShow(false); setTimeout(() => { setI((n) => (n + 1) % items.length); setShow(true); }, 450); }, 4200);
    return () => clearInterval(t);
  }, [items]);
  return (
    <div className="mt-4 flex items-center gap-2 text-sm text-blue-200/90 h-5" data-testid="hero-ticker" aria-live="polite">
      <span className="relative flex h-2 w-2 shrink-0"><span className="absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-60 animate-ping" /><span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-400" /></span>
      <span className={`font-mono text-[12px] tracking-wide transition-all duration-450 ${show ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-1"}`} data-testid="hero-ticker-text">{items[i]}</span>
    </div>
  );
}
